import { Observable } from 'rxjs';

import { UserEmailModel } from 'user/user-email-model';

export abstract class UserEmailModelRepositoryPort {
	public abstract observeUserEmailModels(
		userId: string
	): Observable<UserEmailModel[]>;

	public abstract saveUserEmailModels(
		emailModels: UserEmailModel[]
	): Promise<void>;
}
